import { Popconfirm, Table, Tooltip, Switch, message } from "antd";
import moment from "moment";
import { CiEdit } from "react-icons/ci";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { PUT } from "../../../utils/apiCalls";
import API from "../../../config/api";
function DataTable(props: any) {
  const Events = useSelector((state: any) => state.Events);
  const user = useSelector((state: any) => state.User.user);

  const getTypeLabel = (type: string) => {
    const typeMap: { [key: string]: string } = {
      custom: "Custom Email Template",
      acknowledge: "Acknowledge Email Template",
      notification: "Notification Email Template",
    };
    return typeMap[type] || type;
  };

  const columns = [
    {
      title: "Template Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (type: string) => getTypeLabel(type),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_: any, record: any) => (
        record?.type === "custom" ? (
          <span>-</span>
        ) : (
        <Switch
          checked={!!record?.status}
          onChange={async (checked) => {
            try {
              const payload = {
                id: record?.id,
                eventId: Events?.defult?.id,
                type: record?.type,
                status: checked,
              };
              const res: any = await PUT(API.MAIL_TEMPLATE_STATUS_UPDATE, payload);
              if (res?.status) {
                message.success("Status updated");
                props?.onStatusChange && props.onStatusChange();
              } else {
                message.error("Failed to update status");
              }
            } catch (e) {
              message.error("Failed to update status");
            }
          }}
        />)
      )
    },

    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (item: any) => (
        <div style={{ fontSize: 12 }}>{moment(item).format("MMM D, YYYY h:mm:ss A")}</div>
      ),
    },
    {
      title: "Actions",
      render: (item: any) => (
        <div className="table-item">
            {Array.isArray(user.access[Events?.defult?.id]) &&
               user.access[Events?.defult?.id].includes(8) ? null : 
               <>
          <div onClick={() => props.onChange(item)}>
            <Tooltip
              placement="top"
              title={<div style={{ fontSize: 10 }}>Edit Template</div>}
            >
              <CiEdit size={25} />
            </Tooltip>
          </div>
          <Popconfirm
            title="Delete"
            description="Are you sure to delete this?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => {
              props?.delete(item?.id);
            }}
          >
            <div>
              <IoIosCloseCircleOutline size={25} color="red" />
            </div>
          </Popconfirm>
          </>}
        </div>
      ),
    },
  ];

  return (
    <>
      <Table
        size="small"
        dataSource={props?.data}
        columns={columns}
        pagination={false}
        loading={props?.loading}
      />
    </>
  );
}

export default DataTable;
